import React from "react";
import { BUSINESS } from "../config/business";

const FooterCompanyInfo: React.FC = () => {
  return (
    <div className="flex flex-col items-center text-center py-10">

      {/* 🔥 Brand Name */}
      <h2 className="text-3xl font-extrabold tracking-[-0.03em] text-white md:text-4xl">
        {BUSINESS.siteName}
      </h2>

      {/* Divider */}
      <div className="mb-6 mt-4 h-[2px] w-20 bg-[#7DD3FC]" />

      <p className="max-w-2xl text-sm leading-relaxed text-white/70 md:text-base">
        Bengaluru installation service for{" "}
        <span className="font-medium text-[#7DD3FC]">
          balcony safety nets, pigeon protection nets
        </span>
        , invisible grills and site specific netting for homes and commercial spaces.
      </p>

      <a
        href={BUSINESS.emailUrl}
        className="mt-5 inline-flex min-h-11 max-w-full items-center justify-center rounded-full border border-[#7DD3FC]/35 bg-white/8 px-5 py-2.5 text-sm font-bold text-[#BAE6FD] transition hover:border-[#7DD3FC]/70 hover:bg-white/12 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7DD3FC] focus-visible:ring-offset-2 focus-visible:ring-offset-[#082F49]"
      >
        <span className="break-all">{BUSINESS.email}</span>
      </a>

      <div className="flex flex-wrap justify-center gap-6 mt-6 text-sm">
        <div>
          <p className="text-lg font-bold text-[#7DD3FC]">24/7</p>
          <p className="text-xs text-white/70">Business enquiries</p>
        </div>
        <div>
          <p className="text-lg font-bold text-[#7DD3FC]">Clear</p>
          <p className="text-xs text-white/70">Written scope</p>
        </div>
        <div>
          <p className="text-lg font-bold text-[#7DD3FC]">On site</p>
          <p className="text-xs text-white/70">Measurement available</p>
        </div>
      </div>

      {/* Trust Tags */}
      <div className="mt-6 flex flex-wrap justify-center gap-3 text-xs text-white/70">
        <span className="px-3 py-1 rounded-full bg-white/5 border border-white/10">
          Site specific scope
        </span>
        <span className="px-3 py-1 rounded-full bg-white/5 border border-white/10">
          Material options explained
        </span>
        <span className="px-3 py-1 rounded-full bg-white/5 border border-white/10">
          Installation handover
        </span>
      </div>

      <div className="mt-7">
        <p className="text-[10px] font-extrabold uppercase tracking-[0.16em] text-white/70">
          Our Google Business locations
        </p>
        <div className="mt-3 flex flex-col justify-center gap-3 sm:flex-row">
          {BUSINESS.locations.map((location) => (
            <a
              key={location.id}
              href={location.googleProfileUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-12 flex-col items-center justify-center rounded-xl border border-[#7DD3FC]/35 bg-white/8 px-5 py-3 text-[#7DD3FC] transition hover:border-[#7DD3FC]/70 hover:bg-white/12 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7DD3FC] focus-visible:ring-offset-2 focus-visible:ring-offset-[#082F49]"
            >
              <span className="text-[10px] font-extrabold uppercase tracking-[0.12em] text-white/70">
                {location.label}
              </span>
              <strong className="mt-1 text-sm">View Google profile</strong>
            </a>
          ))}
        </div>
      </div>

      <p className="mt-6 max-w-xl text-xs text-white/70">
        Contact Servani Safety Nets with your location, opening photos and approximate size for an installation quote.
      </p>
    </div>
  );
};

export default FooterCompanyInfo;
